export const baseData = {
  title: 'Rencana Proyek',
  title2: 'Proyek',
  baseLink: '/human-resource/approval/rencana-proyek',
};
